import { useEffect } from "react";
import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();

  useEffect(() => {
    console.error("🔥 Erro capturado pela ErrorPage:", error);

    if (error instanceof Error) {
      console.error("Mensagem:", error.message);
      console.error("Stack:", error.stack);
    }
  }, [error]);

  let title = "Oops!";
  let message = "Algo inesperado aconteceu.";
  let details = "";

  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`;
    message = "Erro ao carregar a página.";
  } else if (error instanceof Error) {
    details = error.message;
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>{title}</h1>
        <p style={styles.message}>{message}</p>

        {details && <pre style={styles.details}>{details}</pre>}

        <Link to="/" style={styles.button}>
          Voltar para Home
        </Link>
      </div>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#0f172a",
    color: "#fff",
    fontFamily: "sans-serif",
  },
  card: {
    background: "#1e293b",
    padding: "40px",
    borderRadius: "16px",
    textAlign: "center",
    maxWidth: "500px",
    width: "90%",
    boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
  },
  title: {
    fontSize: "48px",
    marginBottom: "10px",
  },
  message: {
    fontSize: "18px",
    marginBottom: "20px",
  },
  details: {
    background: "#020617",
    padding: "10px",
    borderRadius: "8px",
    fontSize: "14px",
    marginBottom: "20px",
  },
  button: {
    display: "inline-block",
    padding: "12px 20px",
    background: "#38bdf8",
    color: "#000",
    borderRadius: "8px",
    textDecoration: "none",
    fontWeight: "bold",
  },
};
